var option_webview_default = {
  "option": "RS0hj",
  "user_choice": "osaoW",
  "check": "lrO2K",
  "image": "ZYjg-",
  "input": "eArUw",
  "title": "bqnXb",
  "centered": "bwCe6",
  "with_result": "TqTZ9",
  "list": "_9dHAL",
  "with_image": "dk4kJ",
  "progress": "x-S6C",
  "progress_value": "dbF6O",
  "label": "i0ph6",
  "cta": "XChsU",
  "adornment_icon": "huikN",
  "remove": "ZOt3S",
  "removeButton": "HlGRk",
  "removeButtonIcon": "_56aRt",
  "overlay": "n-wuJ",
  "shown": "_8FsLz",
  "dark": "tNV2R",
  "spinner": "xsFX5",
  "spin": "w3hVu",
  "grid": "PaE6G"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
